import AppRoutes from './routes/AppRoutes';
import './App.css';

function App() {
  return <AppRoutes />;
}

export default App;
